import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { ThemeProvider } from "emotion-theming"
import theme from "@rebass/preset"
import "./layout.css"

const customTheme = {
  ...theme,
  fonts: {
    body: "futura-pt",
    heading: "bookmania",
  },
}

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={customTheme}>
      <Helmet>
        <script
          src="https://kit.fontawesome.com/dd84ce042c.js"
          crossorigin="anonymous"
        ></script>
      </Helmet>
      {children}
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
